// Here redirect that what should be the home page
export var __N_SSP = true;
export { default } from './demo';